import { useState } from "react";

import AddCircleRounded from "@mui/icons-material/AddCircleRounded";
import { IconButton } from "@mui/material";

import { AssignmentCreationDialog } from "@/common/components/assignments/assignment-creation/AssignmentCreationDialog";
import { useTranslation } from "@/translations";

export function AssignmentCreationButton() {
  const { t } = useTranslation();
  const [showAssignmentCreationDialog, setShowAssignmentCreationDialog] = useState(false);

  return (
    <>
      <IconButton onClick={() => setShowAssignmentCreationDialog(true)} aria-label={t("assignments.create")}>
        <AddCircleRounded />
      </IconButton>
      {showAssignmentCreationDialog && (
        <AssignmentCreationDialog onClose={() => setShowAssignmentCreationDialog(false)} />
      )}
    </>
  );
}
